import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../components/styles/header.css';
import Logo from './imgs/DevsSystemsLogo.png';

function Header() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const closeSidebar = () => {
        setSidebarOpen(false);
    };

    return (
        <div className='header'>
            <span className="spamLogo">
                <Link to="/">
                    <img className='devLogo' src={Logo} alt="Devs Systems Logo" />
                </Link>
                <h1 className="nomeEmpresa">Dev´s <span className="systems">Systems</span></h1>
            </span>
            <div className='btnContainer desktop'>
                <Link to="/" onClick={closeSidebar}><button>Home</button></Link>
                <Link to="/projetos" onClick={closeSidebar}><button>Projetos</button></Link>
                <Link to="/contato" onClick={closeSidebar}><button>Contato</button></Link>
                <Link to="/sobre" onClick={closeSidebar}><button>Sobre</button></Link>
            </div>
            <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
                <button onClick={toggleSidebar} className='closeBtn'>×</button>
                <Link to="/" onClick={closeSidebar}><button>Home</button></Link>
                <Link to="/projetos" onClick={closeSidebar}><button>Projetos</button></Link>
                <Link to="/contato" onClick={closeSidebar}><button>Contato</button></Link>
                <Link to="/sobre" onClick={closeSidebar}><button>Sobre</button></Link>
            </div>
            {!sidebarOpen && (
                <button className='menuBtn' onClick={toggleSidebar}>
                    ☰
                </button>
            )}
        </div>
    );
}

export default Header;
